
import { createSlice } from '@reduxjs/toolkit';
 
import { message } from 'antd';

import axios from 'axios'
 
import keyUri from '../../key'

export const initialState = {

    loading: false,
    enquiry:false,
    hasErrors: false,
    all_contact:[],
    currentenquiry:null,
}

export const contactEnquirySlice = createSlice({
    name:"contactEnquiry",
    initialState,
    reducers:{

        getContactEnquiry: state =>{

            state.loading = true
        },

        getContactEnquirySuccess: (state, {payload}) =>{
            state.loading = false
            state.all_contact = payload 
        },

        getCurrentContactEnquiry: (state, {payload}) =>{
          console.log({k:payload});

            state.loading = false
            state.currentenquiry = payload
            
        },
        getContactEnquiryFailure: (state) =>{

            state.loading = false
         
            
        },
      

    }
})

export const {getContactEnquiry, getContactEnquirySuccess, getCurrentContactEnquiry, getContactEnquiryFailure } = contactEnquirySlice.actions
      
export const contactEnquirySelector = state => state.contactEnquiry


const config = {
  headers: {
    'Content-Type': 'application/json'
    }
  };



 


export const  createContactEnquiry = (values) => async dispatch =>{
  console.log(values);
    const key = " ContactEnquiry"
    dispatch(getContactEnquiry())
    // message.loading({ content: 'loading...', key })
    
  try {

      const data = await axios.post(keyUri.BACKEND_URI +'/contactenquiry', values, config);
      console.log(data)
 
      dispatch(getContactEnquirySuccess(data))  
        // window.location.reload()
        
      } catch ({response}) {
        
        dispatch(getContactEnquiryFailure())
      }
      
    }
    
    export const  fetchAllEnquiry = () => async dispatch =>{
      const key = "contact"
      dispatch(getContactEnquiry())
      
      try {
        
        const {data} = await axios.get(keyUri.BACKEND_URI +'/contactenquiry');
        console.log(data)
    dispatch(getContactEnquirySuccess(data))

  } catch ({response}) {
    
    dispatch(getContactEnquiryFailure())
    response.data && message.error({ content: response.data.msg, key, duration: 2 });
    
  }

}


export default contactEnquirySlice.reducer
 


 




